import { Box } from "@mui/material";

import { useEffect, useState } from "react";

//import PolicyUpdateForm from "./form";
import { AccountsandFinanceurl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { DepreciationSchedulesColumns,  } from "../../../../data/DynamicTable/Collumns";
import {allDepreciationSchedules} from "../../../../data/Columns/Queries/FixedAssetManagement/fixedAssetsmanagement";
import DepreciationScheduleForm from "./form";

const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Depreciation Schedules",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "id",
     inputObjectName: "activateDeactivateDepreciationSchedule",
     required: "id"
  },

  showStatus: true,
};
function DepreciationSchedules() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Depreciation Schedules"
          subtitle="View all depreciation schedules, add and edit"
          columns={DepreciationSchedulesColumns}
          FormComponent={DepreciationScheduleForm}
          actions={actions}
          query={allDepreciationSchedules}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default DepreciationSchedules;
